import { __exports as EAN13 } from "./index199.js";
import { __require as requireConstants } from "./index200.js";
import { __require as requireEAN } from "./index201.js";
var hasRequiredEAN13;
function requireEAN13() {
  if (hasRequiredEAN13) return EAN13;
  hasRequiredEAN13 = 1;
  Object.defineProperty(EAN13, "__esModule", {
    value: true
  });
  var _createClass = /* @__PURE__ */ (function() {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function(Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  })();
  var _get = function get(object, property, receiver) {
    if (object === null) object = Function.prototype;
    var desc = Object.getOwnPropertyDescriptor(object, property);
    if (desc === void 0) {
      var parent = Object.getPrototypeOf(object);
      if (parent === null) {
        return void 0;
      } else {
        return get(parent, property, receiver);
      }
    } else if ("value" in desc) {
      return desc.value;
    } else {
      var getter = desc.get;
      if (getter === void 0) {
        return void 0;
      }
      return getter.call(receiver);
    }
  };
  var _constants = requireConstants();
  var _EAN2 = requireEAN();
  var _EAN3 = _interopRequireDefault(_EAN2);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var checksum = function checksum2(number) {
    var res = number.substr(0, 12).split("").map(function(n) {
      return +n;
    }).reduce(function(sum, a, idx) {
      return idx % 2 ? sum + a * 3 : sum + a;
    }, 0);
    return (10 - res % 10) % 10;
  };
  var EAN13$1 = (function(_EAN) {
    _inherits(EAN132, _EAN);
    function EAN132(data, options) {
      _classCallCheck(this, EAN132);
      if (data.search(/^[0-9]{12}$/) !== -1) {
        data += checksum(data);
      }
      var _this = _possibleConstructorReturn(this, (EAN132.__proto__ || Object.getPrototypeOf(EAN132)).call(this, data, options));
      _this.lastChar = options.lastChar;
      return _this;
    }
    _createClass(EAN132, [{
      key: "valid",
      value: function valid() {
        return this.data.search(/^[0-9]{13}$/) !== -1 && +this.data[12] === checksum(this.data);
      }
    }, {
      key: "leftText",
      value: function leftText() {
        return _get(EAN132.prototype.__proto__ || Object.getPrototypeOf(EAN132.prototype), "leftText", this).call(this, 1, 6);
      }
    }, {
      key: "leftEncode",
      value: function leftEncode() {
        var data = this.data.substr(1, 6);
        var structure = _constants.EAN13_STRUCTURE[this.data[0]];
        return _get(EAN132.prototype.__proto__ || Object.getPrototypeOf(EAN132.prototype), "leftEncode", this).call(this, data, structure);
      }
    }, {
      key: "rightText",
      value: function rightText() {
        return _get(EAN132.prototype.__proto__ || Object.getPrototypeOf(EAN132.prototype), "rightText", this).call(this, 7, 6);
      }
    }, {
      key: "rightEncode",
      value: function rightEncode() {
        var data = this.data.substr(7, 6);
        return _get(EAN132.prototype.__proto__ || Object.getPrototypeOf(EAN132.prototype), "rightEncode", this).call(this, data, "RRRRRR");
      }
      // The "standard" way of printing EAN13 barcodes with guard bars
    }, {
      key: "encodeGuarded",
      value: function encodeGuarded() {
        var data = _get(EAN132.prototype.__proto__ || Object.getPrototypeOf(EAN132.prototype), "encodeGuarded", this).call(this);
        if (this.options.displayValue) {
          data.unshift({
            data: "000000000000",
            text: this.text.substr(0, 1),
            options: { textAlign: "left", fontSize: this.fontSize }
          });
          if (this.options.lastChar) {
            data.push({
              data: "00"
            });
            data.push({
              data: "00000",
              text: this.options.lastChar,
              options: { fontSize: this.fontSize }
            });
          }
        }
        return data;
      }
    }]);
    return EAN132;
  })(_EAN3.default);
  EAN13.default = EAN13$1;
  return EAN13;
}
export {
  requireEAN13 as __require
};
//# sourceMappingURL=index165.js.map
